import { Injectable, inject } from '@angular/core';
import { UserStore } from 'app/modules/users/store/user.store';
import { PermissionType } from 'app/shared/enums/permission-type';
import { Role } from '../enums/role';
import { TUTOR_ROLES } from '../utils/role-utils';

interface PermissionOptions {
    minimumRole?: Role;
    allowedRoles?: Role[];
    allowedPermissions?: PermissionType[];
    requiredPermissions?: PermissionType[];
}

@Injectable({
    providedIn: 'root'
})
export class PermissionsService {
    private _userStore = inject(UserStore);

    getCurrentRole(): Role {
        return this._userStore.user()!.role;
    }

    isTutor(): boolean {
        return this.checkPermissions({ allowedRoles: [...TUTOR_ROLES] });
    }

    checkPermissions(permissionOptions: PermissionOptions = {}): boolean {
        const user = this._userStore.user()!;
        let { minimumRole, allowedRoles, allowedPermissions, requiredPermissions } = permissionOptions;

        if (!minimumRole && minimumRole !== Role.None && !allowedRoles) {
            minimumRole = Role.ReadOnly;
        }

        const userPermissions = new Set(user.permissions);
        const hasMinimumRole = minimumRole !== undefined && user.role <= minimumRole;
        const hasAllowedRole = allowedRoles?.some(r => user.role === r) ?? false;
        const hasAllowedPermission = allowedPermissions?.some(p => userPermissions.has(p)) ?? false;
        const hasRequiredPermission = requiredPermissions?.every(p => userPermissions.has(p)) ?? false;

        return hasMinimumRole || hasAllowedRole || hasAllowedPermission || hasRequiredPermission;
    }
}
